import api from "./API";
import ApiEndpointConstants, {
  url,
  DEFAULT_CONTENT_IDS,
  DEFAULT_CONTENT_TYPE,
  DEFAULT_CONTENTS_TITLE,
  DEFAULT_CONTENTS_TITLE_2,
  DEFAULT_FBQ_TOKEN,
  DEFAULT_PIXEL_ID,
  POST_MEASSGE_GROUP_ID,
} from "../constants/ApiEndpointConstants";
import LocalStorageUtil from "../utils/LocalStorageUtil";
import cookie from "react-cookies";
import { getFbPixel } from "./GetPixelAPI";
import { postMessage } from "./PostMessageAPI";
import { initGoogleAds } from "../utils/googleTag";
import { initFacebookPixel } from "../utils/facebookTag";
import { generateEventId } from "../utils/RandomGeneratorUtils";
import { countPixelEvent } from "./CountPixelEventAPI";
import getWWWUrl from "../utils/getWWWUrl";
import { setConfig } from "../store/configSlice";
import { store } from "../store";
import { initTikTokPixel } from "../utils/tiktokTag";

function cleanLangString(str) {
  return str
    .replace(/[“”]/g, '"')
    .replace(/[‘’]/g, "'")
    .replace(/\u00A0/g, " ")
    .replace(/\uFEFF/g, "");
}

// 兼容解析
function parseLangList(str) {
  if (typeof str === "object") {
    return str;
  }

  try {
    str = cleanLangString(str);

    try {
      return JSON.parse(str);
    } catch (e) {}

    return Function(`return (${str})`)();
  } catch (e) {
    console.error("langlist解析失败", e);
    console.log(str);

    return {};
  }
}

// 获取配置
export async function getConfigFromUrl(url) {
  if (!url) return null;
  const newUrl = getWWWUrl(url);
  const res = await getFbPixel(newUrl);
  const data = res?.data?.data;
  if (!data) return null;
  const config = {
    tgid: data.tgid,
    langlist: parseLangList(data.langlist),
    fbqToken: data.fbqToken,
    pixel: data.pixel,
    amount: data.amount,
    amount_fast: data.amount_fast,
    groupid: data.groupid,
    googlePixel: data.googlePixel,
    adPlatform: data.adPlatform,
    tiktok_pixel: data.tiktok_pixel,
    tiktok_token: data.tiktok_token,
  };
  store.dispatch(setConfig(config));
  return config;
}

export const Facebook = (
  event_id,
  eventname,
  customdata,
  userdata,
  fbqToken,
  pixel,
  orderNu,
) => {
  let _fbc = cookie.load("_fbc", { path: "/" });
  let _fbp = cookie.load("_fbp", { path: "/" });
  _fbc = _fbc ? _fbc : "";
  _fbp = _fbp ? _fbp : "";
  userdata["fbc"] = _fbc;
  userdata["fbp"] = _fbp;

  if (!userdata.client_ip_address) {
    delete userdata.client_ip_address;
  }
  if (!userdata.client_user_agent) {
    delete userdata.client_user_agent;
  }

  return api.post(`${ApiEndpointConstants.FACEBOOK}`, {
    event_id: event_id,
    eventname: eventname,
    customdata: customdata,
    userdata: userdata,
    fbqToken: fbqToken,
    pixel: pixel,
    orderNu: orderNu,
  });
};

export const submitFBConversionEvent = async (
  eventname,
  customdata,
  userdata,
  event_id,
  orderNu,
) => {
  let _fbc = cookie.load("_fbc", { path: "/" });
  let _fbp = cookie.load("_fbp", { path: "/" });
  const config = await getConfigFromUrl(url); // ✅ 等待配置返回
  if (!config) return;

  const fbclid = LocalStorageUtil.loadFbclid();
  const entryTimestamp = LocalStorageUtil.loadEntryTimestamp();
  if (!_fbc || (_fbc && _fbc.trim() === "")) {
    if (fbclid && fbclid.trim() !== "") {
      // 手动根据 fbclid 生成fbc参数
      if (entryTimestamp && entryTimestamp.trim() !== "") {
        _fbc = `fb.1.${entryTimestamp}.${fbclid}`;
      } else {
        const now = new Date().getTime();
        _fbc = `fb.1.${now}.${fbclid}`;
      }
    }
  }

  _fbc = _fbc ? _fbc : "";
  _fbp = _fbp ? _fbp : "";

  if (!userdata) {
    userdata = {
      em: "",
      ph: "",
      fn: "",
      ln: "",
      ct: "",
      st: "",
      zp: "",
      country: "",
      external_id: "",
      fbc: _fbc,
      fbp: _fbp,
      // "lead_id": "",
      // "anon_id": "",
      // "madid": "",
      // "page_id": "",
      // "page_scoped_user_id": "",
      // "ctwa_clid": "",
      // "ig_account_id": "",
      // "ig_sid": ""
    };
  } else {
    userdata = Object.assign({}, userdata, { fbc: _fbc, fbp: _fbp });
  }

  const formatCustomData = Object.assign({}, customdata, {
    content_ids: DEFAULT_CONTENT_IDS,
    content_name: DEFAULT_CONTENTS_TITLE,
    content_type: DEFAULT_CONTENT_TYPE,
    contents: [
      {
        id: DEFAULT_CONTENT_IDS[0],
        title: DEFAULT_CONTENTS_TITLE,
        quantity: 1,
      },
    ],
    currency: "USD",
    num_items: 1,
  });
  let res = await api.post(`${ApiEndpointConstants.FACEBOOK}`, {
    eventname,
    customdata: formatCustomData,
    userdata,
    event_id,
    orderNu,
    pixel: config.pixel,
    fbqToken: config.fbqToken,
  });
  let resData = res?.data;
  postMessage(
    `[Facebook - ${eventname}|event_id : ${event_id}] : res data is --[${JSON.stringify(resData)}]--`,
    POST_MEASSGE_GROUP_ID,
  );
  return res;
};

export const submitGGconversionEvent = async (eventName, params = {}) => {
  const config = await getConfigFromUrl(url);
  if (!config) return null;
  const adPlatform = config.adPlatform;
  if (adPlatform === "Google") {
    if (typeof window.gtag !== "function") {
      postMessage(
        `[Google] gtag not initialized: ${eventName}`,
        POST_MEASSGE_GROUP_ID,
      );
      return;
    }
    window.gtag("event", eventName, params);
  }
};

export async function initTracking() {
  const config = await getConfigFromUrl(url);
  if (!config) return;
  const adPlatform = config.adPlatform;

  if (adPlatform === "Google" && config.googlePixel) {
    initGoogleAds(config.googlePixel);
  }
  if (config.pixel) {
    initFacebookPixel(config.pixel);
  }
  if (config.tiktok_pixel) {
    initTikTokPixel(config.tiktok_pixel);
  }
  const eventId = generateEventId("PageView", DEFAULT_CONTENT_IDS[0]);
  // 后台漏斗
  countPixelEvent("Page View", eventId);
}
